































































































































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BFormCheckbox,
  BPagination,
  BRow,
  BTable,
  BBadge,
  BAlert,
  BFormDatepicker,
  BFormGroup
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { ShortOpportunite } from "@/api/models/opportunites/opportunite";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import ViewOpportunite from '@/views/adherents/opportunites/ViewOpportunite.vue'
import SearchableVueSelect from '@/components/selects/SearchableVueSelect.vue'
import { UserDetail } from "@/api/models/authorization/userDetails/userDetail";
import { DetailsUtilisateur, ShortUtilisateur } from "@/api/models/utilisateurs/utilisateur";

@Component({
  components: {
    BCard,
    BAlert,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormCheckbox,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BBadge,
    BFormDatepicker,
    BFormGroup,
    ViewOpportunite,
    SearchableVueSelect
  },
})
export default class ListOpportunites extends Vue {
  perPage = 25;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  timeout: any = null;
  searchQuery = "";
  isSortDirDesc = false;
  sortBy = "libelle";

  isViewOpportuniteModalActive = false
  selectedOpportuniteId = ''

  // Filtres
  filterStatut: string | null = null
  filterResponsable: string | null = null
  filterNatureOffre: string | null = null
  filterJoursSansAction: number | null = null

  listStatuts: { code: string; libelle: string; }[] = [];
  listNatureOffres: { code: string; libelle: string; }[] = [];
  paginatedListResponsables = new PaginatedList<DetailsUtilisateur>()

  tableColumns = [
    { key: "entrepriseLibelle", label:"Entreprise", sortable: true },
    { key: "libelle", label: "Libellé", sortable: true },
    { key: "naturesOffre", label: "Nature(s)", sortable: true },
    { key: "responsableCompleteNom", label: "Responsable", sortable: true },
    { key: "statut", sortable: true },
    { key: "montant", sortable: true },
    { key: "dateDebutSouhaitee", label: "Date prévisionnelle de démarrage", sortable: true },
    // { key: "dateDerniereActu", label: "Date dernière actualité", sortable: false }
    // { key: "actions", sortable: false }
  ];
  paginatedListOpportunites = new PaginatedList<ShortOpportunite>();

  async created() {
    await this.loadStatuts();
    await this.loadNatureOffres();

    await this.loadListOpportunites({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListOpportunites.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListOpportunites.items.length
    );
  }

  getStatutLibelle(code: string) {
    const statut = this.listStatuts.find((s) => s.code === code);
    return statut ? statut.libelle : code;
  }

  async loadStatuts() {
    this.listStatuts = await this.loadParametre('opportunites_statut')
  }

  async loadNatureOffres() {
    this.listNatureOffres = await this.loadParametre('opportunites_nature_offre')
  }

  async loadResponsables(params: any) {
    await this.$http.myressif.utilisateurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        params?.hiddenUser ?? false,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        this.paginatedListResponsables.items = this.paginatedListResponsables!.items.concat(
          response.items.filter(
            (ri) => !this.paginatedListResponsables!.items.some((lsi) => lsi.id == ri.id)
          )
        ).map((x: ShortUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        this.paginatedListResponsables.hasNextPage = response.hasNextPage
        this.paginatedListResponsables.totalCount = response.totalCount
      })
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string}[]> {
    var response: {code: string, libelle: string}[] = []
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then((res: {valeur: string}) => {
        response = res ? JSON.parse(res.valeur) : [];
      }),
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      };

      return response;
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListOpportunites({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
    });
  }

  @Watch('searchQuery')
  @Watch("filterStatut")
  @Watch("filterResponsable")
  @Watch("filterNatureOffre")
  @Watch("filterJoursSansAction")
  async searchOpportunite() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListOpportunites({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        orderBy: this.sortBy,
        orderByDescending: this.isSortDirDesc,
        search: this.searchQuery,
      })
    }, 1000);
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;
    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    };
    this.isSortDirDesc = !this.isSortDirDesc;
    this.loadListOpportunites(params);
  }

  async loadListOpportunites(params: any) {
    if (!params || params?.reset) {
      this.paginatedListOpportunites = new PaginatedList<ShortOpportunite>();
    }

    await this.$http.myressif.opportunites
      .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? "",
        this.filterStatut ?? undefined,
        this.filterResponsable ?? undefined,
        this.filterNatureOffre ?? undefined,
        this.filterJoursSansAction ?? undefined
      )
      .then((response: PaginatedList<ShortOpportunite>) => {
        this.paginatedListOpportunites = response;
      });
  }

  onRowSelected(record: ShortOpportunite) {
    this.selectedOpportuniteId = record.id
    this.isViewOpportuniteModalActive = true
  }

  async reloadList() {
    await this.loadListOpportunites({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    })
  }
}
